import styled from "@emotion/styled";
import { type MouseEvent } from "react";

import { zIndexes } from "@skilitics/designer-ui-components";

import { useAreaExcludedFromShield, useDeactivateNodePicking, useNodePickingActive } from "./useNodePicking";

const Shield = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.02);
  backdrop-filter: saturate(75%) blur(1.25px);

  z-index: ${zIndexes.shield};
`;

type Props = {
  area?: string;
};

export const PickingShield = ({ area }: Props) => {
  const pickingActive = useNodePickingActive();
  const areaExcluded = useAreaExcludedFromShield(area);
  const deactivateNodePicking = useDeactivateNodePicking();

  if (!pickingActive || areaExcluded) return null;

  const onDeactivateNodePicking = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    deactivateNodePicking();
  };

  return <Shield onClick={onDeactivateNodePicking} />;
};
